module.exports = __webpack_public_path__ + "static/locks_diagram-9989eeec5c2ac947f2244e14122c8912.png";